import { UtxAppEmbed } from '@/design-system/components/utxAppEmbedCallback/utxAppEmbedCallback';
import { useRoute } from '@react-navigation/native';
import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { InstructionSubmittedNativeScreen } from './InstructionSubmittedNative.screen';
import { InstructionSubmittedWebScreen } from './InstructionSubmittedWeb.screen';

export interface InstructionSubmittedProps {}
export const InstructionSubmittedScreen: React.FC<InstructionSubmittedProps> = () => {
  const layout = useContext(LayoutContext);
  const route = useRoute();
  if (layout.isMobile) {
    return (
      <UtxAppEmbed route={route.name}>
        <InstructionSubmittedNativeScreen />
      </UtxAppEmbed>
    );
  }
  return <InstructionSubmittedWebScreen />;
};
